module.exports = __webpack_public_path__ + "img/reply.686cf82d.svg";